import React from "react";
import { useChat } from "../../contexts/ChatProvider";
import ErrorIcon from "../icons/ErrorIcon";
import SuccessIcon from "../icons/SucesssIcon";
import { useLocale } from "../../contexts/LocaleProvider";

const styles = {
    overlay: {
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(15, 15, 20, 0.55)",
        backdropFilter: "blur(2px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1100,
        padding: "16px",
    },
    modal: {
        backgroundColor: "#ffffff",
        borderRadius: "12px",
        boxShadow: "0 20px 40px rgba(0, 0, 0, 0.2)",
        maxWidth: "380px",
        width: "100%",
        padding: "24px",
        textAlign: "center",
        fontFamily:
            "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    },
    title: {
        fontSize: "17px",
        fontWeight: 600,
        color: "#1a1a1a",
        margin: "0 0 8px",
    },
    message: {
        fontSize: "14px",
        color: "#555555",
        lineHeight: 1.5,
        margin: "0 0 24px",
    },
    buttonRow: {
        display: "flex",
        justifyContent: "flex-end",
        gap: "10px",
    },
    cancelButton: {
        padding: "8px 10px",
        borderRadius: "8px",
        border: "1px solid #d9d9d9",
        backgroundColor: "#ffffff",
        color: "#333333",
        fontSize: "12px",
        fontWeight: 600,
        cursor: "pointer",
        transition: "box-shadow 150ms ease, background-color 150ms ease",
    },
    confirmButton: {
        padding: "8px 10px",
        borderRadius: "8px",
        border: "none",
        color: "#ffffff",
        fontSize: "12px",
        fontWeight: 600,
        cursor: "pointer",
        transition: "box-shadow 150ms ease, filter 150ms ease",
    },
};

export default function ConfirmationModal({
    isOpen,
    title = "Are you sure?",
    message = "This action cannot be undone.",
    confirmText = "Confirm",
    cancelText = "Cancel",
    destructive = true,
    onConfirm,
    onCancel,
    error,
    success,
    showCloseButton,
    disableConfirm
}) {
    const { t } = useLocale();
    const { theme, confirmatModalTitle, confirmationModalMessage } = useChat();
    if (!isOpen) return null;

    return (
        <div style={styles.overlay} onClick={onCancel}>
            <div
                style={styles.modal}
                role="alertdialog"
                aria-modal="true"
                aria-labelledby="confirmation-modal-title"
                onClick={(e) => e.stopPropagation()}
            >
                <div style={{display: "flex", justifyContent: "center", gap: 2}}>
                    {error && <ErrorIcon />}
                    {success && <SuccessIcon />}
                    <h2 id="confirmation-modal-title" style={styles.title}>
                        {confirmatModalTitle ? confirmatModalTitle : title}
                    </h2>
                </div>
                
                <p style={styles.message}>{confirmationModalMessage ? confirmationModalMessage : message}</p>
                <div style={styles.buttonRow}>
                    <button type="button" style={styles.cancelButton} onClick={onCancel}>
                        {(error || success) ? t("common.close") : cancelText}
                    </button>
                    {!(error || success) && <button
                        disabled={disableConfirm}
                        type="button"
                        style={{
                            ...styles.confirmButton,
                            cursor: disableConfirm ? "progress" : "pointer",
                            backgroundColor: destructive ? "#e5484d" : theme,
                        }}
                        onClick={onConfirm}
                    >
                        {confirmText}
                    </button>}
                </div>
            </div>
        </div>
    );
}